import axios from 'axios';

// 创建 axios 实例
const axiosInstance = axios.create({
  baseURL: `${window.location.protocol}//${window.location.hostname}:3000`, // 配置你的 API 基础路径
  timeout: 5000, // 请求超时设置
  headers: {
    'Content-Type': 'application/json',
  }
});

// 请求拦截器：可以在请求发出之前做一些处理，比如添加 token 和参数
axiosInstance.interceptors.request.use(
  (config) => {
    // 例如：检查本地存储中的 token 并附加到请求头中
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // 新增请求参数，例如 userId
    const userId = localStorage.getItem('userId');
    if (userId) {
      if (config.method === 'get') {
        config.params = config.params || null; // 确保 params 存在
        config.params.userId = userId; // 只在 GET 请求时加参数
      } else if (config.method === 'post') {
        config.data = config.data || null; // 确保 data 存在
        config.data.userId = userId; // 在 POST 请求的请求体中加参数
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器：可以在请求响应之后做一些处理
axiosInstance.interceptors.response.use(
  (response) => {
    return response.data;  // 只返回响应的 data 数据
  },
  (error) => {
    console.error('API 请求失败：', error);
    return Promise.reject(error);
  }
);

// 导出封装好的 axios 实例
export default axiosInstance;

// 请求示例
// this.$axios.post('/some-endpoint', {
//   key1: 'value1',
//   key2: 'value2',
//   additionalParam: 'extraValue', // 动态传递额外参数
// })
// .then((response) => {
//   console.log('响应数据:', response);
// })
// .catch((error) => {
//   console.error('请求失败:', error);
// });